import { FinancialSituationModelsWrapper } from "./models-wrapper";

export default function FinancialSituationModelsPage() {
  return <FinancialSituationModelsWrapper />;
}
